<div class="levels" [style]="style" *ngIf="levels.loaded" fxLayout="row wrap">
  <div *ngFor="let name of levels.names" fxLayout="column"
       [class.current]="levels.names[levels.index]===name"
       (click)="pickLevel(name)"
  >
    <span>{{name}}</span>
    <a [href]="'?l='+levels.indexOf(name)">
      <img [src]="levels.levels[name].src" class="miniature" [style]="miniStyle"/>
    </a>
  </div>
</div>
